// CartModel.ts
import { EventEmitter } from '../base/event';
export class CartModel extends EventEmitter {
    constructor() {
        super();
        this._items = [];
    }
    addToCart(product) {
        const existing = this._items.find(item => item.product.id === product.id);
        if (existing) {
            existing.quantity++;
        }
        else {
            this._items.push({
                product: Object.assign({}, product),
                quantity: 1
            });
        }
        this.emitChange();
    }
    removeFromCart(productId) {
        this._items = this._items.filter(item => item.product.id !== productId);
        this.emitChange();
    }
    clearCart() {
        this._items = [];
        this.emitChange();
    }
    getCartState() {
        return {
            items: this._items.map(item => ({
                product: Object.assign({}, item.product),
                quantity: item.quantity
            })),
            totalPrice: this.calculateTotalPrice(),
            totalItems: this.getItemsCount()
        };
    }
    getItemsCount() {
        return this._items.reduce((sum, item) => sum + item.quantity, 0);
    }
    calculateTotalPrice() {
        return this._items.reduce((sum, item) => sum + (item.product.price || 0) * item.quantity, 0);
    }
    emitChange() {
        this.emit('cart-change', this.getCartState());
    }
}
